export { default as MarketShare } from './primary';
